import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actionCreators from "../actions/actionCreators.js";


import PrintPage from "../components/PrintPage";


function mapStateToProps(state){
	//console.log("Connecting state", state.series);
	return {
		lang: state.data.lang,
		auth: state.data.auth
	}
}

function mapDispatchToProps(dispatch){
	return bindActionCreators(actionCreators, dispatch);
}


const PrintPageContainer = connect(mapStateToProps, mapDispatchToProps)(PrintPage);

export default PrintPageContainer;


// WEBPACK FOOTER //
// ./src/containers/PrintPageContainer.js